import {OverlayModule} from "@angular/cdk/overlay";
import {PortalModule} from "@angular/cdk/portal";
import {CommonModule} from "@angular/common";
import {ModuleWithProviders, NgModule} from "@angular/core";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import { RegisterInterestMessageComponent } from "../shared/components/product/register-interest-message/register-interest-message.component";
import {ContentSearchService} from "../content-search/services/content-search.service";
import {AutocompleteComponent} from "../shared/components/form-controls/autocomplete/autocomplete.component";
import {DropdownComponent} from "../shared/components/form-controls/dropdown/dropdown.component";
import {FacetComponent} from "../shared/components/form-controls/facet/facet.component";
import {PaginationComponent} from "../shared/components/form-controls/pagination/pagination.component";
import {EmptySearchResultComponent} from "../shared/components/product/empty-search-result/empty-search-result.component";
import {ProductsListViewComponent} from "../shared/components/product/products-list-view/products-list-view.component";
import {QueryStringSerializationService} from "../shared/services/query-string-serialization.service";
import {DialogComponent} from "./components/dialog/dialog.component";
import {CounterComponent} from "./components/form-controls/counter/counter.component";
import {MultiDropdownComponent} from "./components/form-controls/multi-dropdown/multi-dropdown.component";
import {SearchTextComponent} from "./components/form-controls/search-text/search-text.component";
import {JsonDataComponent} from "./components/json-data/json-data.component";
import {NotificationComponent} from "./components/notification/notification.component";
import {PopoverComponent} from "./components/popover/popover.component";
import {AddToCartPaneComponent} from "./components/product/add-to-cart-pane/add-to-cart-pane.component";
import {ProductPreviewComponent} from "./components/product/product-preview/product-preview.component";
import {ProductPriceComponent} from "./components/product/product-price/product-price.component";
import {SpinnerComponent} from "./components/spinner/spinner.component";
import {ApiResultDispatcherService} from "./services/api/api-result-dispatcher.service";
import {ApiService} from "./services/api/api-service";
import {DialogService} from "./services/components/dialog.service";
import {NotificationService} from "./services/components/notification.service";
import {ConfigurationService} from "./services/configuration.service";
import {LoggerService} from "./services/logger.service";
import {ProductCartService} from "./services/product/product-cart.service";
import {ProductService} from "./services/product/product.service";
import {WishListService} from "./services/product/wish-list-service";
import {WindowRefService} from "./services/window-ref.service";
import {RegisterInterestPopUpComponent} from "./components/product/register-interest-pop-up/register-interest-pop-up.component";
import { ConditionListsPopUpComponent} from "./components/product/condition-lists-pop-up/condition-lists-pop-up.component";
import { ProductMtaPopUpComponent} from "./components/product/product-mta-pop-up/product-mta-pop-up.component";
import { QuickViewPopUpComponent } from "./components/product/quick-view-pop-up/quick-view-pop-up.component";
import { ConditionListsAgreementComponent } from "./components/product/condition-lists-agreement/condition-lists-agreement.component";
import { ProductMtaAgreementComponent } from "./components/product/product-mta-agreement/product-mta-agreement.component";
import { DiscontinuedMessageComponent } from "./components/product/discontinued-message/discontinued-message.component";
import { DiscontinuedProductPopUpComponent } from "./components/product/discontinued-product-pop-up/discontinued-product-pop-up.component";
import { NotificationsWidgetComponent } from "./components/notification/notifications-widget/notifications-widget.component";
import { DepositorsListComponent } from "./components/product/depositors-list/depositors-list.component";
import { DistributorsListComponent } from "./components/product/distributors-list/distributors-list.component";

@NgModule({
    imports: [
        OverlayModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        PortalModule
    ],
    declarations: [
        SpinnerComponent,
        NotificationComponent,
        CounterComponent,
        DialogComponent,
        SearchTextComponent,
        AddToCartPaneComponent,
        ProductPreviewComponent,
        ProductsListViewComponent,
        ProductPriceComponent,
        JsonDataComponent,
        PaginationComponent,
        FacetComponent,
        EmptySearchResultComponent,
        DropdownComponent,
        AutocompleteComponent,
        MultiDropdownComponent,
        PopoverComponent,
        RegisterInterestMessageComponent,
        RegisterInterestPopUpComponent,
        ConditionListsAgreementComponent,
        ConditionListsPopUpComponent,
        ProductMtaAgreementComponent,
        ProductMtaPopUpComponent,
        QuickViewPopUpComponent,
        DiscontinuedMessageComponent,
        DiscontinuedProductPopUpComponent,
        NotificationsWidgetComponent,
        DepositorsListComponent,
        DistributorsListComponent
    ],
    exports: [
        CommonModule,
        ReactiveFormsModule,
        PortalModule,
        SpinnerComponent,
        CounterComponent,
        NotificationComponent,
        DialogComponent,
        SearchTextComponent,
        AddToCartPaneComponent,
        ProductPreviewComponent,
        ProductsListViewComponent,
        ProductPriceComponent,
        JsonDataComponent,
        PaginationComponent,
        FacetComponent,
        EmptySearchResultComponent,
        DropdownComponent,
        AutocompleteComponent,
        MultiDropdownComponent,
        PopoverComponent,
        RegisterInterestMessageComponent,
        RegisterInterestPopUpComponent,
        ConditionListsAgreementComponent,
        ConditionListsPopUpComponent,
        ProductMtaAgreementComponent,
        ProductMtaPopUpComponent,
        QuickViewPopUpComponent,
        DiscontinuedMessageComponent,
        DiscontinuedProductPopUpComponent,
        NotificationsWidgetComponent,
        DepositorsListComponent,
        DistributorsListComponent
    ],
    providers: [
        WindowRefService,
        LoggerService,
        ConfigurationService,
        NotificationService,
        ApiService,
        ApiResultDispatcherService,
        DialogService,
        ProductCartService,
        ProductService,
        WishListService,
        QueryStringSerializationService,
        ContentSearchService
    ]
})
export class SharedModule {
    public static forRoot(): ModuleWithProviders {
        return {
            ngModule: SharedModule
        };
    }
}
